export default __webpack_public_path__ + "static/media/colinKozmaDesktop.49bdba7e.jpg";